import React from 'react';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import ComplexTable from './ComplexTable';
import ArrowBackIcon from '../../../images/arrow-black.png';
import ChangeComplexStartDateModal from './ChangeComplexStartDateModal';

const SingleComplexItem = ({
  complex,
  getPDF,
  confirmDeleting,
  transformedComplexStatus,
  onStatusChange,
  changeComplexPauseStatus,
  changeComplexStartDate,
}) => {
  const [isOpened, setIsOpened] = React.useState(false);
  const [isChangeComplexStartDate, setIsChangeComplexStartDate] = React.useState(false);

  const open = () => {
    setIsOpened(!isOpened);
  };

  const onChangeComplexStartDate = (startDate) => {
    changeComplexStartDate(complex.id, startDate);
  };

  return (
    <Item>
      <Name onClick={open}>
        <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened} />
        {complex.name}
        <PdfButton onClick={(event) => getPDF(event, complex.id)}>pdf</PdfButton>
      </Name>
      {isOpened && (
        <Collapse key={complex.id} isOpened>
          <ComplexTable
            complex={complex}
            confirmDeleting={confirmDeleting}
            setIsChangeComplexStartDate={setIsChangeComplexStartDate}
            transformedComplexStatus={transformedComplexStatus}
            onStatusChange={onStatusChange}
            changeComplexPauseStatus={changeComplexPauseStatus}
          />
        </Collapse>
      )}
      <ChangeComplexStartDateModal
        isShow={isChangeComplexStartDate}
        onClose={setIsChangeComplexStartDate}
        changeComplexStartDate={onChangeComplexStartDate}
      />
    </Item>
  );
};

export default SingleComplexItem;

const Item = styled.div`
  width: 80%;
  margin: 15px auto;
  box-sizing: border-box;
  border: 2px solid #c1c1c1;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
`;

const Name = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 80px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    padding: 0 160px 0 55px;
  }
  @media (max-width: 768px) {
    height: auto;
    padding: 20px 10px 60px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
  @media (max-width: 350px) {
    font-size: 20px;
  }
`;

const ImgArrow = styled.img`
  position: absolute;
  left: 15px;
  bottom: 25px;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;

const DeleteButton = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 10px;
  bottom: 15px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 40px;
    height: 40px;
    bottom: 20px;
  }
  @media (max-width: 768px) {
    bottom: 10px;
  }
`;

const PdfButton = DeleteButton.extend`
  background: #157aac;
  right: 70px;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    right: 60px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Menus/ControlUsers/SingleComplexItem.jsx